// extracted by mini-css-extract-plugin
export default {"card":"Products_card__rKtBh","price":"Products_price__r4PRA"};